import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { FaChartBar, FaClock, FaSignOutAlt, FaCog, FaCrown } from 'react-icons/fa';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import UserSettings from './UserSettings';
import './Analytics.css';
import CompleteProfile from './CompleteProfile';
import Listings from './Listings';
import { IoPerson } from "react-icons/io5";
import { FaOpenid } from 'react-icons/fa';
import axios from 'axios';
import { formatDistanceToNow, isPast } from 'date-fns';
import { GiUpgrade } from 'react-icons/gi';
import GetJournalists from './GetJournalists';
import { Badge } from "flowbite-react";
import { HiMiniPencilSquare } from "react-icons/hi2";
import { FaPencil } from "react-icons/fa6";
import LeadPage from './LeadPage';
import Footer from './Footer';
const Dashboard = () => {
    const { logout, user } = useAuth0();
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);

    const handleUpgrade = async() => {
        console.log('User:', user);
        const id = userData._id
        // const clientReferenceId = user.sub.split('|')[1];
        window.location.href = `https://buy.stripe.com/14k5o69LQaoOdmE5km?client_reference_id=${encodeURIComponent(id)}`;
    };

    useEffect(() => {
        const fetchUserData = async () => {
          try {
            const response = await axios.get('https://pressconnect-backend-99be5a99f8df.herokuapp.com/api/user-settings', {
              params: {
                sub: user.sub
              }
            });
            setUserData(response.data);
          } catch (error) {
            console.error('Error fetching user data:', error);
          }
        };
    
        fetchUserData();
      }, [userData]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const getHeaderTitle = () => {
        switch (location.pathname) {
            case "/dashboard":
                return "Matches";
            case "/dashboard/settings":
                return "Settings";
            case "/dashboard/complete-profile":
                return "Profile";
            case "/dashboard/journalists":
              return (
                <span className='flex'>
                  Journalists <Badge 
                  className="mr-2 ml-2 w-[100px] flex justify-center items-center text-center"
                  color="pink">
                    BETA</Badge>
                </span>
              );;
            default:
                return "Matches";
        }
    };

    const renderUpgradeButton = () => (
        <button
          onClick={handleUpgrade}
          type="button"
          className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800 ml-auto"
        >
          <span className="flex relative px-5 py-2.5 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 hover:bg-gradient-to-bl transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            <GiUpgrade className="mr-1" />
            Upgrade Plan
          </span>
        </button>
      );
    
      const renderTrialInfo = () => {
        const trialEnd = new Date(userData.trialEndDate);
        if (isPast(trialEnd)) {
          return renderUpgradeButton();
        } else {
          const daysLeft = formatDistanceToNow(trialEnd, { addSuffix: true });
          return (
            <button
              type="button"
              onClick={handleUpgrade}
              className="flex items-center text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            >
              <FaClock className="mr-1" />
              Trial ends {daysLeft}
            </button>
          );
        }
      };

    return (
        <div className={`dashboard-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
            <aside className="dashboard-sidebar">
                <div className="sidebar-header">
                    <h1 className="flex items-center">
                        <FaOpenid className="mr-2" />
                        PressRequest
                    </h1>
                    <button className="sidebar-close" onClick={toggleSidebar}>×</button>
                </div>
                <nav className="sidebar-nav">
                <div className="sidebar-top">
                    <button
                        onClick={() => navigate("/dashboard")}
                        className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                        <FaChartBar className="text-lg" />
                        <span>Dashboard</span>
                    </button>
                    <button
                        onClick={() => navigate("/dashboard/settings")}
                        className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                        <FaCog className="text-lg" />
                        <span>Settings</span>
                    </button>
                    <button
                      onClick={() => navigate("/dashboard/complete-profile")}
                      className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      <div className="flex items-center">
                        <IoPerson className="text-lg" />
                      </div>
                      <div className="relative flex items-center">
                        <span>Profile</span>
                        {userData !== null && userData.expertise.length === 0 && (
                          <span className="absolute right-[-25px] top-1/2 transform -translate-y-1/2 text-yellow-300 text-lg">
                            ←
                          </span>
                        )}
                      </div>
                    </button>

                    {/* <button
                        onClick={() => navigate("/dashboard/journalists")}
                        className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                        <div className="relative flex items-center">
                        {userData !== null && userData.expertise.length === 0 && (
                              <span className="absolute left-[-9px] w-1 h-1 bg-yellow-300 rounded-full animate-pulse"></span>
                          )}
                            <HiMiniPencilSquare className="text-lg" />
                        </div>
                        <span>Journalists</span>
                    </button> */}
                </div>
                    <div className="sidebar-bottom">
                        <div className="user-profile">
                            <img src={user.picture} alt="User Avatar" className="user-avatar" />
                            <div className="user-info">
                                <span className="user-name">{user.name.includes('@') ? user.name.split('@')[0] : user.name}
                                </span>
                            </div>
                        </div>
                        <button 
                            className="logout-button" 
                            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                        >
                            <FaSignOutAlt />
                        </button>
                    </div>
                </nav>
            </aside>
            <div className="dashboard-content">
                <header className="dashboard-header">
                    <button className="sidebar-toggle" onClick={toggleSidebar}>
                        <span className="sidebar-toggle-icon"></span>
                    </button>
                    <h1>{getHeaderTitle()}</h1>
                    {userData ? (
                        userData.isPro ? 
                        <button
                            type="button"
                            className="flex items-center relative inline-flex justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800 ml-auto"
                            >
                            <span className="flex items-center relative px-5 py-2.5 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 hover:bg-gradient-to-bl transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                                <FaCrown className="mr-1" />
                                Pro Plan
                            </span>
                        </button>
                        : renderTrialInfo()
                    ) : (
                    <span>Loading...</span>
                    )}
                    {/* <button 
                        onClick={handleUpgrade}
                        type="button" 
                        className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800 ml-auto"
                    >
                    <span className="flex relative px-5 py-2.5 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 hover:bg-gradient-to-bl transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                        <GiUpgrade className="mr-1"/>
                        Upgrade Plan
                    </spanxw>
                    </button> */}
                </header>
                <main className="dashboard-main">
                    <Routes>
                        <Route path="/" element={<Listings/>} />
                        <Route path="settings" element={<UserSettings />} />
                        <Route path="complete-profile" element={<CompleteProfile />} />
                        <Route path="journalists" element={<GetJournalists />} />
                        <Route path="listing/:id" element={<LeadPage />} /> {/* Updated */}
                        </Routes>
                        
                </main>
            </div>
        </div>
    );
}

export default Dashboard;